var toggle = require('bootstrapToggle'),
    owlcarousel = require('owlcarousel'),
    userService = require('userService'),
    folderService = require('folderService'),
    loader = require('loader'),
    modal = require('modal'),
    notification = require('notification'),
    formValidation = require('formValidation'),
    backgroundColour = require('backgroundColour'),
    wordCount = require('wordCount');

var folders = (function() {
    var $folderNameInput = $('input[name=folder_name]'),
        $clearFolderBtn = $('.clear-folder-btn'),
        $createFolderBtn = $('#create-folder-btn'),
        $updateFolderBtn = $('#update-folder-btn'),
        $deleteFolderBtn = $('#delete-folder-btn'),
        $backFolderBtn = $('#back-folder-btn'),
        $editConentBackBtn = $('#edit-folder-btn-back'),
        $editFolderBtn = $('#edit-folder-btn'),
        $contentBtn = $('.remove-from-folders a'),
        $sharingOptions = $('.sharing-options input[type=checkbox]'),
        $folderMarkup = $('.item-wrapper.new-folder'),
        $activeBtn = null,
        $activeFolder = null,
        $form = $('#folder-form'),
        user_id = $('body').attr('data-user-id'),
        folder_id = null,
        newFolderShare = null;


    const itemCount = function($item) {
      var count = 1;
      $item.each(function() {
        $('span.folder-number', this).text(count);
        count++;
      });
      return this;
    };


    var imageShuffle = function() {
        $(".folder").each(function() {
            var position = 0;
            $('.images li', this).each(function() {
                $(this).css("top", position + 'px');
                position += 15;
            });
        });
    };


    var folderCarousel = function() {
        $('.folder-carousel').owlCarousel({
            dots: true,
            navigation: false,
            slideSpeed: 500,
            mouseDrag: false,
            autoHeight: true,
            responsive: {
                0: {
                    items: 1
                },
                992: {
                    items: 2
                }
            }
        });
    };


    var activeItem = function() {
        $(document).on('click', '.folder.card', function(e) {
            e.stopPropagation();
            if(!$(e.target).hasClass('btn')) {
                $('.folder.card.active').removeClass("active");
                $(this).addClass("active");
                $activeFolder = $(this);
                folder_id = $(this).attr('data-folderid') || null;
                $('.folder-item').removeClass('display');
                $(".folder-item[data-folderid='" + folder_id + "']").addClass('display');
                $('#replace-for-active').text('You currently dont have any content in this folder, to add some content select and article or drill and click on the "add to folder" button');
                emptyContent();
                checkAccessRights($(this));
            }
        });
    };


    var emptyContent = function() {
        if($('.folder-item.display').length) {
            $('.empty-content').addClass('display');
        } else {
            $('.empty-content').removeClass('display');
        }
    };


    var emptyFolders = function() {
        var count = $('.folder.card').length;
        if(count == 1) {
            $('.empty-folder.dynamic').removeClass('display');
        } else {
            $('.empty-folder').addClass('display');
            $folderNameInput.val('');
            $sharingOptions.prop('checked', false);
        }
    };


    var folderPulse = function() {
        $('.right-panel').addClass('pulse');
        setTimeout(function() {
            $('.right-panel').removeClass('pulse');
        }, 1500);
    };


    var checkAccessRights = function($this) {
        if(window.matchMedia('(max-width: 992px)').matches) {
            const owl = $('.folder-carousel').owlCarousel();
            owl.trigger('next.owl.carousel');
            updateSlide('content');
        }

        if($this.hasClass('shared')) {
            $editFolderBtn.addClass('hide');

        } else {
            $('.right-panel').closest('.owl-item').show();
            $editFolderBtn.removeClass('hide');
            updateSlide('content');
        }
    };


    var backBtn = function() {
        $backFolderBtn.on("click", function() {
            const owl = $('.folder-carousel').owlCarousel();
            owl.trigger('prev.owl.carousel');
            updateSlide('content');
            $('#edit-folder-title').show();
            $('#create-folder-title').hide();
        });

        $editFolderBtn.on("click", function() {
            const owl = $('.folder-carousel').owlCarousel();
            owl.trigger('next.owl.carousel');
            updateSlide('details');
            $('#edit-folder-title').show();
            $('#create-folder-title').hide();
            updatingDisplayContent();
        });
    };


    var updateSlide = function(slide) {
        var folder = $('.folders');
        folder.removeClass('overview details content create load');
        switch(slide) {
            case 'overview':
                folder.addClass('overview');
                break;
            case 'details':
                folder.addClass('details');
                break;
            case 'content':
                folder.addClass('content');
                break;
            case 'create':
                folder.addClass('create');
                break;
            default:
                folder.addClass('load');
        }
    };


    var updatingDisplayContent = function() {
        var folderName = $('.information h2', $activeFolder).text();
        $folderNameInput.val(folderName);
        var sharedTeams = [];

        if($('.folder-share', $activeFolder).is(':checked')) {
            $('svg.unlocked use').attr("xlink:href", "#icon-locked").attr('xlink:href', '#icon-unlocked');
            $('.right-panel .folder-share').prop('checked', true).change().attr('data-folderid', folder_id);

        } else {
            $('svg.unlocked use').attr("xlink:href", "#icon-unlocked").attr('xlink:href', '#icon-locked');
            $('.right-panel .folder-share').prop('checked', false).change();
        }


        $('.shared-team', $activeFolder).each(function() {
            sharedTeams.push($(this).attr("data-team-id"));
        });

        $('.sharing-options input').each(function() {
            if($.inArray($(this).attr("id"), sharedTeams) !== -1) {
                $(this).prop('checked', true);
            } else {
                $(this).prop('checked', false);
            }
        });
    };


    var folderNameCount = function() {
        var elem = $("#counter");
        $("#folder_name").limiter(30, elem);
    };


    var clearFolder = function() {
        $clearFolderBtn.on("click", function() {
            $folderNameInput.val('');
            $('svg.unlocked use').attr("xlink:href", "#icon-unlocked").attr('xlink:href', '#icon-locked');
            $sharingOptions.prop('checked', false);
            $('#edit-folder-title').hide();
            $('#create-folder-title').show();
            updateSlide('create');
            selectPanel();
            folderPulse();
        });
    };


    var selectPanel = function() {
        const owl = $('.folder-carousel').owlCarousel();
        var firstSlide = $(".owl-dot")[0],
            secondSlide = $(".owl-dot")[1],
            thridSlide = $(".owl-dot")[2];

        if(window.matchMedia('(min-width: 992px)').matches) {
            secondSlide.click();
        } else {
            thridSlide.click();
        }

    };


    var formValidation = function() {
        $form.validate({
            rules: {
                folder_name_input: {
                    required: true,
                    maxlength: 29
                }
            },
            submitHandler: function() {}
        });
    };


    var checkFolderExists = function($btn) {
        $btn.on("click", function(e) {
            e.preventDefault();
    //        if( $form.valid() ) {
                if(!$(this).hasClass('clicked-link')) {
                    $(this).addClass('clicked-link');
                    $('window').showLoader();
                    var title = $folderNameInput.val();
                    if($btn.is('#create-folder-btn')) {
                        checkExistsFolderService(user_id, title, 0, checkFolderExistsResponse);
                    } else {
                        checkExistsFolderService(user_id, title, folder_id, renameFolderExistsResponse);
                    }
                }
        //    }
        });
    };


    var checkFolderExistsResponse = function(response) {
        $createFolderBtn.removeClass('clicked-link');
        if(response.statusCode === 200) {
            createFolder();
        } else {
            $('window').notification({
                title: response.message,
                error: true
            });
        }
    };


    var createFolder = function() {
        var item = {};
        item.user_id = user_id;
        item.title = $folderNameInput.val();
        item.team_id_list = teamShare();
        item.share = folderShareCheck($('.folder-share-new'));

        var data = JSON.stringify(item);
        createFolderService(data, createFolderResponse);
        $(".owl-dot")[0].click();
    };


    var createFolderResponse = function(response) {
        var folder_id = response.data.id;
        if(response.statusCode === 200) {
            $('window').notification({
                title: response.message
            });
            animateCreate(folder_id);
        } else {
            $('window').notification({
                title: response.message,
                error: true
            });
        }
    };


    var animateCreate = function(folder_id) {
        var team_list_inputs = [];
        $('.sharing-options input').each(function() {
            const team_id = $(this).attr("id");
            if($(this).is(':checked')) {
                team_list_inputs.push('<input type="hidden" class="shared-team" data-team-id="' + team_id + '">');
            }
        });


        var $newItem = $folderMarkup.clone().removeAttr('hidden');
        var shareStatus = folderShareCheck($('.folder-share-new'));

        $newItem.addClass('animate transition');
        $newItem.find('.folder').attr('data-folderid', folder_id);
        $newItem.find('h2').text($folderNameInput.val());
        $newItem.find('.new-share').attr('id', 'new-share');
        $newItem.find('.new-share').attr('data-toggle', 'toggle');
        $newItem.find('.new-share').attr('data-folderid', folder_id);
        $newItem.find('.folder').append(team_list_inputs);
        $newItem.find('.new-share').bootstrapToggle();

        if(shareStatus === true) {
            $newItem.find('.new-share').prop('checked', true).change();
        } else {
            $newItem.find('.new-share').prop('checked', false).change();
        }
        if($(".folder-wrap .item-wrapper:last-of-type").length) {
            $newItem.insertBefore(".folder-wrap .item-wrapper:first-of-type");
        } else {
            $newItem.insertAfter(".folder-wrap .folders-insert");
        }

        setTimeout(function() {
            $newItem.addClass('loaded');
        }, 800);

        emptyFolders();
        $('window').backgroundColour($(".folder.card"));
        itemCount($(".folder.card"));
    };


    var deleteFolderCheck = function() {
        $deleteFolderBtn.on("click", function() {
            if(!$(this).hasClass('clicked-link')) {
                $(this).addClass('clicked-link');
                selectPanel();
                $('window').modal({
                    title: 'Delete ' + $folderNameInput.val() + ' Folder?',
                    content: '<p>Are you sure you want to delete this folder? This action cannot be undone.</p>',
                    confirmText: 'Delete',
                    complete: function() {
                        deleteFolderService(user_id, folder_id, deleteResponse);
                        $('window').showLoader();
                        $(".owl-dot")[0].click();
                        updateSlide('content');
                    }
                });
            }
        });
    };


    var deleteResponse = function(response) {
        $deleteFolderBtn.removeClass('clicked-link');
        if(response.statusCode === 200) {
            $('window').notification({
                title: response.message
            });
            animateDelete();
        } else {
            $('window').notification({
                title: response.message,
                error: true
            });
        }
    };


    var animateDelete = function() {
        $activeFolder.removeClass('transition').animate({}, function() {
            $(this).animate({
                'height': '0px',
                'padding': '0px',
                'margin-bottom': '0px'
            }, function() {
                $(this).remove();
                itemCount($(".folder.card"));
                emptyFolders();
            });
        });
    };



    var renameFolderExistsResponse = function(response) {
        $updateFolderBtn.removeClass('clicked-link');
        if(response.statusCode === 200) {
            renameFolder();
        } else {
            $('window').notification({
                title: response.message,
                error: true
            });
        }
    };


    var renameFolder = function() {
        var item = {};
        item.user_id = user_id;
        item.folder_id = folder_id;
        item.title = $folderNameInput.val();
        var data = JSON.stringify(item);

        renameFolderService(data, renameFolderResponse);
        var team_id_list = teamShare();
        teamShareUpdate();
        teamShareAPICall(folder_id, team_id_list);
        $(".owl-dot")[0].click();
        updateSlide('overview');
        $('window').showLoader();
    };


    var renameFolderResponse = function(response) {
        if(response.statusCode === 200) {
            $('window').notification({
                title: response.message
            });
            $('.information h2', $activeFolder).text($folderNameInput.val());
        } else {
            $('window').notification({
                title: response.message,
                error: true
            });
        }
    };


    var removeContent = function() {
        $contentBtn.on('click', function(e) {
            e.preventDefault();
            if(!$(this).hasClass('clicked-link')) {
                $(this).addClass('clicked-link');
                $('window').showLoader();

                $activeBtn = $(this).closest($('.folder-btns'));
                var content_id = $activeBtn.attr('data-model-id');
                var content_type = $activeBtn.attr('data-model-type');

                var item = {};
                item.folder_id = folder_id;
                item.content_id = content_id;
                item.content_type = content_type;

                var data = JSON.stringify(item);

                if($(this).hasClass('remove')) {
                    deleteContentFromFolderService(folder_id, content_id, content_type, removeContentResponse);
                    updateContentCount('minus');
                } else if($(this).hasClass('undo')) {
                    addContentToFolderService(data, removeContentResponse);
                    updateContentCount('plus');
                }
            }
        });
    };


    var removeContentResponse = function(response) {
        if(response.statusCode === 200) {
            $('window').notification({
                title: response.message
            });
            toggleActiveBtn();
        } else {
            $('window').notification({
                title: response.message,
                error: true
            });
            $('.active').removeClass('clicked-link');
        }
    };


    var updateContentCount = function(action) {
        var itemSpan = parseInt($('.folder.card.active .item-count span').text(), 10),
            itemNumber;
        switch(action) {
            case 'plus':
                itemNumber = itemSpan + 1;
                break;
            case 'minus':
                itemNumber = itemSpan - 1;
                break;
        }
        $('.item-count span', $activeFolder).text(itemNumber);
    };


    var toggleActiveBtn = function() {
        if($activeBtn.hasClass('slide-btns')) {
            $('.clicked-link').addClass('removing-active');
            $('.removing-active').one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function() {
                $(this).removeClass('active clicked-link removing-active').siblings().addClass('active');
            });
        } else {
            $('.clicked-link').removeClass('active clicked-link').siblings().addClass('active');
        }
    };


    var folderFilters = function() {
        var $btns = $('.filters .option').on("click", function() {
            var $this = $(this).attr('data-option');
            if($this == 'both') {
                $('.folder-wrap article').show();
                $('.selected-option').text("All folders");
            } else {
                var $option = $('.folder-wrap article.' + $this);
                $option.show();
                $('.folder-wrap article').not($option).hide();

                if($this == 'owned') {
                    $('.selected-option').text("Your personal folders");
                } else {
                    $('.selected-option').text("Folders shared with you");
                }
            }
        });
    };


    var folderShare = function() {
        $(document).on('click', '.right-panel .checkbox', function() {
            if($(this).find('.folder-share').is(':checked')) {
                $('.folder-share', $activeFolder).prop('checked', true).change();
            } else {
                $('.folder-share', $activeFolder).prop('checked', false).change();
            }
        });

        $(document).on('change', '.left-panel .folder-share', function() {
            var folder_id = $(this).attr('data-folderid');
            var share_toggle = folderShareCheck($(this));
            folderShareAPI(folder_id, share_toggle);
        });
    };


    var folderShareCheck = function($this) {
        var share_toggle;
        if($this.parent().hasClass('off')) {
            share_toggle = false;
        } else {
            share_toggle = true;
        }
        return share_toggle;
    };


    var folderShareAPI = function(folder_id, share_toggle) {
        var item = {};
        item.share = share_toggle;
        item.folder_id = folder_id;
        var data = JSON.stringify(item);
        shareAFolderService(data, folderShareResponse);
    };


    var folderShareResponse = function(response) {
        if(response.statusCode === 200) {
            $('window').notification({
                title: response.message
            });
        } else {
            $('window').notification({
                title: response.message,
                error: true
            });
        }
    };


    var teamShare = function(folder_id) {
        var team_id_list = [];
        let team_id;
        $('.sharing-options input').each(function() {
            team_id = $(this).attr("id");
            if($(this).is(':checked')) {
                team_id_list.push(team_id);
            }
        });
        return team_id_list;
    };


    var teamShareUpdate = function() {
        $('.sharing-options input').each(function() {
            const team_id = $(this).attr("id");
            if($(this).is(':checked')) {
                if(!$('input[data-team-id="' + team_id + '"]', $activeFolder).length) {
                    $activeFolder.append('<input type="hidden" class="shared-team" data-team-id="' + team_id + '">');
                }
            } else {
                $('input[data-team-id="' + team_id + '"]', $activeFolder).remove();

            }
        });
    };


    var teamShareAPICall = function(folder_id, team_id_list) {
        var item = {};
        item.folder_id = folder_id;
        item.team_id_list = team_id_list;
        var data = JSON.stringify(item);
        updateFolderTeamIDListService(data);
    };


    var init = function() {
        itemCount($('.folder.card'));
        $('window').backgroundColour($('.folder.card'));
        checkFolderExists($createFolderBtn);
        checkFolderExists($updateFolderBtn);
        imageShuffle();
        folderCarousel();
        activeItem();
        backBtn();
        clearFolder();
        deleteFolderCheck();
        removeContent();
        emptyFolders();
        folderFilters();
        folderShare();
        folderNameCount();
    };

    return {
        init: init
    };
})();

if($('.folder-carousel').length) {
    folders.init();
}



// WEBPACK FOOTER //
// ./library/js/modules/folders.js